<template>
  <div class="login-with-app" v-if="isLoginApp">
  <div class="login-layout blur-login" :style="{ backgroundImage: `url(${require('@/assets/images/bg.png')})` }">
    <a v-if="isSupport" class="btn-support-index" href="https://support.alligate.me/hc/ja" target="_blank"><i class="fa fa-question-circle"></i><br>ヘルプ</a>
  <div id="mainContainer" class="main-container">
    <div class="main-content">
      <div class="">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div class="position-relative">
              <div id="login-box">
                <div >
                  <div >
                    <span  v-if="loginProcess === 2 && isNTT !== true" class = "btn-back" @click="goBackLogin()"><i class="glyphicon glyphicon-chevron-left"></i> 戻る</span>
                    <span  v-if="loginProcess === 3" class = "btn-back" @click="goBack()"><i class="glyphicon glyphicon-chevron-left"></i> 戻る</span>
                    <h4 class="header blue lighter bigger i-logo">
                      <img :src="logoLogin" alt="logo"  width="150"/>
                    </h4>
                    <!-- <h1 class="notice-title" v-if="(env !== 'production' && env !== 'staging1' && env !== 'staging2') ">{{env}}</h1> -->
                    <form @submit.prevent="validateBeforeSubmit" novalidate >
                      <fieldset  v-if="lProcess == 1">
                        <div v-if="loginProcess === 1">
                          <div class="form-item width-80" v-if="loginProcess === 1 || credentials.ownerId === ''">
                            <input autocomplete="off" required v-if="isNTT" disabled v-on:keyup.enter="next()" id="ownerId" name="ownerId" type="text" class="form-control" @blur="validateBeforeSubmit(1)"  v-model="credentials.ownerId" data-vv-as="名前"/>
                            <input autocomplete="off" required v-else v-on:keyup.enter="next()" id="ownerId" name="ownerId" type="text" class="form-control" @blur="validateBeforeSubmit(1)" v-model="credentials.ownerId" data-vv-as="名前"/>
                            <label>事業者ID</label>
                            <span v-bind:class="[error === '' ? 'hidden error' : 'error']">
                              {{ error }}
                            </span>
                            <span id="ownerId_error" v-bind:class="[error !== '' ? 'hidden error' : 'error']"></span>
                          </div>
                          <div v-if="loginProcess === 1 || credentials.ownerId === ''" class="clearfix login-button">
                            <button type="submit" @mousedown="next" v-bind:class="{'bg_black': isNTT, '' : !isNTT}">
                              <span><img :src="`${require('@/assets/images/icon/arrow.png')}`" class="btn-icon"></span>
                              <span >次へ進む</span>
                            </button>
                          </div>
                          <div v-if="(loginProcess === 1 || credentials.ownerId === '') && isGuest === true && isNTT === false" class="clearfix login-button btn-guest">
                            <button type="button" @click="useGuest()" class="">
                              <span><img :src="`${require('@/assets/images/icon/account.png')}`" class="btn-icon"></span>
                              <span >ゲスト利用</span>
                            </button>
                          </div>
                        </div>
                        <!-- step 2 -->
                        <div v-if="loginProcess === 2 && isNTT" class="register-new-account-link">
                          <a v-bind:href = "registerLink" class="register-new-account-link">
                            アカウント新規登録
                          </a>
                        </div>
                        <div v-if="loginProcess === 2">
                          <div class="form-item width-80" v-if="credentials.ownerId !== ''">
                            <input autocomplete="off" required  name="userID" id="userID" class="form-control"  @blur="validateBeforeSubmit(2)" />
                            <label v-if="isNTT">会員ID</label>
                            <label v-else>ユーザーID</label>
                            <span class="error" id="userID_error"></span>
                          </div>
                          <div class="form-item width-80" v-if="credentials.ownerId !== ''">
                            <input autocomplete="off" required  id="password" name="password" type="password" class="form-control" @blur="validateBeforeSubmit(3)"/>
                            <label for="password" >パスワード</label>
                            <div class="newpassword-showhide" style="display:inline-block">
                            <span class="show-password icon-eye" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img :src="`${require('@/assets/images/icon/eye.png')}`" ></span>
                            <span class="hide-password icon-eye" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img :src="`${require('@/assets/images/icon/eye-off.png')}`"></span>
                            </div>
                            <span v-bind:class="[error === '' ? 'hidden error' : 'error']">
                              {{ error }}
                            </span>
                            <span v-bind:class="[error !== '' ? 'hidden error' : 'error']" id="password_error"></span>
                          </div>
                          <div v-if="credentials.ownerId !== ''" class="clearfix login-button">
                            <button  type="submit" @click="signIn()">
                              <span><img :src="`${require('@/assets/images/icon/next.png')}`" class="btn-icon"></span>
                              <span >ログイン</span>
                            </button>
                          </div>
                          <div class="forgot-password-text" v-if="loginProcess === 2">
                            <router-link tag="a" :to="{ name: 'forgotpassword'}" class="forgot-password-link">
                              <span><img :src="`${require('@/assets/images/icon/arrow-w.png')}`" class="btn-icon-link"></span>
                              パスワードが分からない場合
                            </router-link>
                          </div>
                          <hr>
                          <div class="forgot-password-text" v-if="loginProcess === 2" @click="expandIdentityProvider()">
                              <span>
                                <img  v-if="isExpandIP" :src="`${require('@/assets/images/icon/up.png')}`" class="btn-icon-link" >
                                <img  v-else :src="`${require('@/assets/images/icon/down.png')}`" class="btn-icon-link" ></span>
                              外部アカウントでログイン
                          </div>
                          <transition name="slide">
                          <div v-if="isExpandIP">
                            <div  v-if="googleLoginInfo.isValid" class="clearfix login-button btn-guest">
                              <button type="button" @click="signInWithIdentityProvider(googleLoginInfo.cognitoIdProviderName)">
                                <span><img :src="`${require('@/assets/images/icon/google.png')}`" class="btn-icon"></span>
                                <span >Googleでログイン</span>
                              </button>
                            </div>
                            <div  v-if="appleLoginInfo.isValid" class="clearfix login-button btn-guest">
                              <button type="button" @click="signInWithIdentityProvider(appleLoginInfo.cognitoIdProviderName)">
                                <span><img :src="`${require('@/assets/images/icon/apple.png')}`" class="btn-icon"></span>
                                <span >Appleでサインイン</span>
                              </button>
                            </div>
                            <div  v-if="oneloginLoginInfo.isValid" class="clearfix login-button btn-guest">
                              <button type="button" @click="signInWithIdentityProvider(oneloginLoginInfo.cognitoIdProviderName)">
                                <span><img :src="`${require('@/assets/images/icon/one.png')}`" class="btn-icon"></span>
                                <span >SAMLでログイン</span>
                              </button>
                            </div>
                          </div>
                          </transition>
                        </div>
                        <label v-if="loginProcess === 3" class="block clearfix"> <!-- step 3 -->
                          <span class="block input-icon input-icon-right">
                            <input v-validate="'required'" name="mfaCode" id="mfaCode" type="text" class="form-control" placeholder="認証コード" v-model="mfaCode" @blur="validateBeforeSubmit"/>
                          </span>
                          <span class="error" id="mfaCode_error"></span>
                        </label>
                        <div v-if="loginProcess === 3" class="clearfix login-button">
                          <button type="submit" @click="confirmSignin(mfaCode)" class="width-80">
                            <span class="bigger-110 login-text">OK</span>
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </div><!-- /.widget-main -->
                </div><!-- /.widget-body -->
              </div><!-- /.login-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
  </div>
  <div class="login-layout blur-login" v-else>
    <a v-if="isSupport" class="btn-support-index" href="https://support.alligate.me/hc/ja" target="_blank"><i class="fa fa-question-circle"></i><br>ヘルプ</a>
    <div id="mainContainer" class="main-container">
      <div class="main-content">
        <div class="row">
          <div class="col-sm-12">
            <div class="login-container">
              <div class="position-relative">
                <div id="login-box" class="login-box visible widget-box no-border">
                  <div class="widget-body">
                    <div class="widget-main">
                      <span  v-if="loginProcess === 2 && isNTT !== true" class = "btn-back" @click="goBackLogin()"><i class="glyphicon glyphicon-chevron-left"></i> 戻る</span>
                      <span  v-if="loginProcess === 3" class = "btn-back" @click="goBack()"><i class="glyphicon glyphicon-chevron-left"></i> 戻る</span>
                      <h4 class="header blue lighter bigger logo-login-default">
                        <img :src="logo" alt="logo" />
                      </h4>
                      <h1 class="notice-title" v-if="(env !== 'production' && env !== 'staging1' && env !== 'staging2') ">{{env}}</h1>
                      <div class="alert alert-danger" v-if="error">
                        {{ error }}
                      </div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <fieldset  v-if="lProcess == 1">
                          <label v-if="loginProcess === 1 || credentials.ownerId === ''" class="block clearfix"> <!-- step 1 -->
                            <span id="ownerId_error" class="error"></span>
                            <span class="block input-icon input-icon-right">
                              <input v-if="isNTT" disabled v-on:keyup.enter="next()" id="ownerId" name="ownerId" type="text" class="form-control" @blur="validateBeforeSubmit(1)"  placeholder="事業者ID" v-model="credentials.ownerId" data-vv-as="名前"/>
                              <input v-else v-on:keyup.enter="next()" id="ownerId" name="ownerId" type="text" class="form-control" @blur="validateBeforeSubmit(1)"  placeholder="事業者ID" v-model="credentials.ownerId" data-vv-as="名前"/>
                            </span>
                          </label>
                          <div v-if="loginProcess === 1 || credentials.ownerId === ''" class="clearfix login-button">
                            <button type="submit" @mousedown="next" v-bind:class="{'width-60 bg_black': isNTT, 'width-60' : !isNTT}">
                              <i class="glyphicon glyphicon-log-in"></i>
                              <span class="bigger-110 login-text">次へ進む</span>
                            </button>
                          </div>
                          <hr class='clear-margin' v-if="(loginProcess === 1 || credentials.ownerId === '') && isGuest === true && isNTT === false">
                          <div v-if="(loginProcess === 1 || credentials.ownerId === '') && isGuest === true && isNTT === false" class="clearfix login-button">
                            <button type="button" @click="useGuest()" class="width-60">
                              <i class="glyphicon glyphicon-log-in"></i>
                              <span class="bigger-110 login-text">ゲスト利用</span>
                            </button>
                          </div>
                          <label v-if="loginProcess === 2 && credentials.ownerId !== ''" class="block clearfix"> <!-- step 2 -->
                            <span class="error" id="userID_error"></span>
                            <span class="block input-icon input-icon-right">
                              <input v-if="isNTT" name="userID" id="userID" class="form-control" placeholder="会員ID" @blur="validateBeforeSubmit(2)" autocomplete="username"/>
                              <input v-else name="userID" id="userID" class="form-control" placeholder="ユーザーID" @blur="validateBeforeSubmit(2)" autocomplete="username"/>
                            </span>
                          </label>
                          <label v-if="loginProcess === 2 && credentials.ownerId !== ''" class="block clearfix">
                            <span class="error" id="password_error"></span>
                            <div  id="round-password" class="block input-icon input-icon-right" style="display:inline-block!important;width:90%">
                              <input id="password" name="password" type="password" class="form-control" placeholder="パスワード" @blur="validateBeforeSubmit(3)" autocomplete="current-password"/>
                            </div>
                            <div class="newpassword-showhide" style="display:inline-block">
                              <span class="show-password" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                              <span class="hide-password" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                            </div>
                          </label>
                          <div v-if="loginProcess === 2 && credentials.ownerId !== ''" class="clearfix login-button">
                            <button type="submit" @click="signIn()" v-bind:class="{'width-60 bg_black': isNTT, 'width-60' : !isNTT}" >
                              <i class="glyphicon glyphicon-log-in"></i>
                              <span class="bigger-110 login-text">ログイン</span>
                            </button>
                          </div>
                          <div class="forgot-password-link" v-if="loginProcess === 2">
                            <router-link tag="a" :to="{ name: 'forgotpassword'}" class="forgot-password-link">
                              <i class="ace-icon fa fa-arrow-right"></i>
                              パスワードが分からない場合
                            </router-link>
                          </div>
                          <hr class='clear-margin' v-if="loginProcess==2">
                          <div v-if="loginProcess === 2 && isNTT" class="register-new-account-link">
                            <a v-bind:href = "registerLink" class="register-new-account-link">
                              アカウント新規登録
                            </a>
                          </div>
                          <div class="login-box-advanced-content" v-if="loginProcess === 2 && googleLoginInfo.isValid">
                            <div class="google-login-button">
                                <div class="federated-login-button">
                                  <button type="button" @click="signInWithIdentityProvider(googleLoginInfo.cognitoIdProviderName)" class="federated-login-button btn-secondary" style="background: rgb(66, 133, 244); color: rgb(255, 255, 255); font-family: Roboto, sans-serif; font-size: 16px;">
                                      <img  src="../../../static/img/btn_google_light_normal_ios.svg" class="google-logo">Googleでログイン
                                    </button>
                                </div>
                            </div>
                          </div>
                          <div class="login-box-advanced-content" v-if="loginProcess === 2 && appleLoginInfo.isValid">
                            <div data-v-007447da="" class="apple-login-button">
                              <div data-v-007447da="" class="federated-login-button">
                                <button type="button" @click="signInWithIdentityProvider(appleLoginInfo.cognitoIdProviderName)" class="federated-login-button btn-secondary" style="background: rgb(0, 0, 0); color: rgb(255, 255, 255); font-size: 16px;">
                                    <img src="../../../static/img/Apple_Left_White_Logo_Large.svg" class="apple-logo">Appleでサインイン
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="login-box-advanced-content" v-if="loginProcess === 2 && oneloginLoginInfo.isValid">
                            <div data-v-049ee9d6="" class="onelogin-login-button">
                              <div data-v-049ee9d6="" class="federated-login-button">
                                <button type="button" @click="signInWithIdentityProvider(oneloginLoginInfo.cognitoIdProviderName)" class="federated-login-button btn-secondary" style="background: rgb(28, 31, 42); color: rgb(255, 255, 255); font-size: 16px;">
                                  SAMLでログイン
                                </button>
                              </div>
                            </div>
                          </div>
                          <label v-if="loginProcess === 3" class="block clearfix"> <!-- step 3 -->
                            <span class="error" id="mfaCode_error"></span>
                            <span class="block input-icon input-icon-right">
                              <input v-validate="'required'" name="mfaCode" id="mfaCode" type="text" class="form-control" placeholder="認証コード" v-model="mfaCode" @blur="validateBeforeSubmit"/>
                            </span>
                          </label>
                          <div v-if="loginProcess === 3" class="clearfix login-button">
                            <button type="submit" @click="confirmSignin(mfaCode)" class="width-60">
                              <span class="bigger-110 login-text">OK</span>
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div><!-- /.widget-main -->
                  </div><!-- /.widget-body -->
                </div><!-- /.login-box -->
              </div><!-- /.position-relative -->
            </div>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.main-content -->
    </div><!-- /.main-container -->
  </div>
</template>

<script>
import { Auth, Hub } from 'aws-amplify'
import * as Config from '../../config'
import router from '../../router'
export default {
  name: 'login',
  data () {
    return {
      env: process.env.NODE_ENV,
      registerLink: process.env.REGISTER_NEW_USER,
      logoLogin: 'static/img/logo-login.png',
      logo: process.env.LOGO_IMAGE,
      credentials: {
        ownerId: '',
        userID: '',
        password: ''
      },
      username: '',
      password: '',
      loginProcess: 1,
      error: '',

      cognitoUser: null,
      mfaCodeError: '',
      federatedLoginServices: [],
      isOneEnable: false,
      isGoogleEnable: false,
      isAppleEnable: false,
      mfaCode: '',
      googleLoginInfo: {
        isValid: false,
        cognitoIdProviderName: ''
      },
      appleLoginInfo: {
        isValid: false,
        cognitoIdProviderName: ''
      },
      oneloginLoginInfo: {
        isValid: false,
        cognitoIdProviderName: ''
      },
      lProcess: 1,
      isGuest: false,
      isSupport: true,
      isNTT: false,
      IpAddress: '',
      isExpandIP: false,
      isLoginApp: false
    }
  },
  created () {
    // Auth.signOut()
    Hub.listen('auth', this.authEventListener)
    var checkGuest = navigator.userAgent.match(/isGuest/)
    if (checkGuest) {
      this.isGuest = true
    }
    var checkNTTWeb = navigator.userAgent.match(/isNTT/)
    if (checkNTTWeb) {
      this.isNTT = true
      this.credentials.ownerId = 'quintbridge'
      this.logo = '../../../static/img/Quintbridge.svg'
      this.credentials.userID = ''
      this.credentials.password = ''
      this.loginProcess = 2
    }
    var isMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios|alligate-mobile-userAgent-android|isNTT|isUpgrade/g)
    if (isMobileApp) {
      if (isMobileApp.indexOf('isNTT') < 0 && isMobileApp.indexOf('isUpgrade') >= 0) {
        this.isLoginApp = true
      } else {
        this.isLoginApp = false
      }
    } else {
      this.isLoginApp = false
    }
    localStorage.removeItem('firstLoad')
    this.getIPAddress()
  },
  mounted () {
    var checkCode = window.location.href.match(/code=/)
    if (checkCode) {
      $('.main-content').append('<div id="loading"><div class="loadingMsg"></div></div>')
    }
    var getCode = this.$route.query.status
    if (getCode !== '' && getCode !== undefined) {
      $('#ownerId_error').html('ログインに失敗しました。ユーザ登録状況について管理者にお問い合わせください。')
    }
    var isMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent/)
    if (isMobileApp) {
      this.isSupport = false
    } else {
      this.isSupport = true
    }
    localStorage.removeItem('loginProcess')
  },
  methods: {
    expandIdentityProvider () {
      this.isExpandIP = !this.isExpandIP
    },
    authEventListener ({ payload: { event, data } }) {
      $('.main-content').append('<div id="loading"><div class="loadingMsg"></div></div>')
      switch (event) {
        case 'signIn':
          this.$auth.saveCurrentAuthenticatedUser()
          break
        case 'signIn_failure':
          this.$auth.errorAuthenticatedUser()
          break
        default:
          break
      }
    },
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    removeLoading () {
      $('div#loading').remove()
    },
    dispLoading () {
      $('.main-content').append('<div id="loading"><div class="loadingMsg"></div></div>')
    },
    next () {
      if (this.validateBeforeSubmit(this.loginProcess)) {
        if (this.loginProcess === 1) {
          var newURL = location.href.split('?')[0]
          window.history.pushState('object', document.title, newURL)
          this.submitOwner()
        }
      }
    },
    submitOwner () {
      this.dispLoading()
      this.$http.get(Config.OWNER_LOGIN_METHOD_API + '?ownerId=' + this.credentials.ownerId)
        .then(response => {
          this.error = ''
          localStorage.setItem('ownerId', this.credentials.ownerId)
          this.credentials.ownerId = this.credentials.ownerId
          this.credentials.userID = ''
          this.credentials.password = ''
          this.loginProcess = 2
          this.federatedLoginServices = response.body.federatedLoginServices
          this.removeLoading()
          $('#ownerId_error').html('')
          $('#ownerId').removeClass('error')
          this.getFederatedLoginServices()
        })
        .catch((error) => {
          console.log(error)
          this.error = '事業者IDが間違っています。'
          this.removeLoading()
          this.federatedLoginServices = []
        })
    },
    getFederatedLoginServices () {
      this.googleLoginInfo.isValid = false
      this.googleLoginInfo.cognitoIdProviderName = ''
      this.appleLoginInfo.isValid = false
      this.appleLoginInfo.cognitoIdProviderName = ''
      this.oneloginLoginInfo.isValid = false
      this.oneloginLoginInfo.cognitoIdProviderName = ''
      const google = this.federatedLoginServices.find((item) => item.name === 'Google')
      const apple = this.federatedLoginServices.find((item) => item.name === 'Apple')
      const onelogin = this.federatedLoginServices.find((item) => item.name === 'Onelogin')
      if (google) {
        this.googleLoginInfo.isValid = true
        this.googleLoginInfo.cognitoIdProviderName = google.cognitoIdProviderName
      }
      if (apple) {
        this.appleLoginInfo.isValid = true
        this.appleLoginInfo.cognitoIdProviderName = apple.cognitoIdProviderName
      }
      if (onelogin) {
        this.oneloginLoginInfo.isValid = true
        this.oneloginLoginInfo.cognitoIdProviderName = onelogin.cognitoIdProviderName
      }
    },

    signInWithIdentityProvider (provider) {
      this.messageHandlerProvider(provider)
    },
    // googleSignIn () {
    // },
    // oneloginSignIn () {
    //   this.messageHandlerProvider(this.oneloginLoginInfo.cognitoIdProviderName)
    //   this.setStartLogin()
    //     .then(() => Auth.federatedSignIn({provider: this.oneloginLoginInfo.cognitoIdProviderName}))
    // },
    // appleidSignIn () {
    //   this.messageHandlerProvider(this.appleLoginInfo.cognitoIdProviderName)
    //   this.setStartLogin()
    //     .then(() => Auth.federatedSignIn({provider: this.appleLoginInfo.cognitoIdProviderName}))
    // },
    signIn (username, password) {
      if (this.validateBeforeSubmit(5)) {
        username = $('#userID').val() + '\\' + this.credentials.ownerId
        password = $('#password').val()
        this.messageHandlerSignIn(username, password)
      }
    },
    confirmSignin () {
      this.dispLoading()
      Auth.confirmSignIn(this.cognitoUser, this.mfaCode, 'SMS_MFA')
        .then((user) => {
          this.removeLoading()
        })
        .catch((error) => {
          this.removeLoading()
          this.error = '認証コードが間違っています。'
          console.log('MFACode:', error)
        })
    },
    validateBeforeSubmit (loginProcess) {
      var userID = ''
      var password = ''
      this.error = ''
      switch (loginProcess) {
        case 1:
          if (this.credentials.ownerId === null || this.credentials.ownerId === '') {
            $('#ownerId_error').html('事業者IDは必須項目です。')
            $('#ownerId').addClass('error')
            return false
          }
          $('#ownerId_error').html('')
          $('#ownerId').removeClass('error')
          return true
        case 2:
          userID = $('#userID').val()
          if (userID === null || userID === '') {
            if (this.isNTT) {
              $('#userID_error').html('会員IDは必須項目です。')
            } else {
              $('#userID_error').html('ユーザーIDは必須項目です。')
            }
            $('#userID').addClass('error')
            return false
          } else {
            $('#userID_error').html('')
            $('#userID').removeClass('error')
            return true
          }
        case 3:
          password = $('#password').val()
          if (password === null || password === '') {
            $('#password_error').html('パスワードは必須項目です。 ')
            $('#password').addClass('error')
            return false
          } else {
            $('#password_error').html('')
            $('#password').removeClass('error')
            return true
          }
        case 4:
          if (this.mfaCode === null || this.mfaCode === '') {
            $('#mfaCode_error').html('認証コードは必須項目です。')
            $('#mfaCode').addClass('error')
            return false
          } else {
            $('#mfaCode_error').html('')
            $('#mfaCode').removeClass('error')
            return true
          }
        case 5:
          userID = $('#userID').val()
          password = $('#password').val()
          var check = true
          if (userID === null || userID === '') {
            if (this.isNTT) {
              $('#userID_error').html('会員IDは必須項目です。')
            } else {
              $('#userID_error').html('ユーザーIDは必須項目です。')
            }
            $('#userID').addClass('error')
            check = false
          } else {
            $('#userID_error').html('')
            $('#userID').removeClass('error')
          }
          if (password === null || password === '') {
            $('#password_error').html('パスワードは必須項目です。 ')
            $('#password').addClass('error')
            check = false
          } else {
            $('#password_error').html('')
            $('#password').removeClass('error')
          }
          return check
        default:
          return true
      }
    },
    goBackLogin () {
      this.dispLoading()
      setTimeout(() => {
        this.loginProcess = 1
        this.removeLoading()
      }, 10)
      if (this.isNTT === false) {
        this.credentials.ownerId = ''
      }
      this.credentials.userID = ''
      this.credentials.password = ''
      this.error = ''
    },
    goBack () {
      this.dispLoading()
      setTimeout(() => {
        this.loginProcess = 2
        this.removeLoading()
      }, 10)
      this.credentials.userID = ''
      this.credentials.password = ''
      this.error = ''
    },
    setStartLogin () {
      return new Promise((resolve, reject) => {
        const authStore = this.$store.state.auth
        authStore.isLoginChallenge = true
        this.$store.commit('UPDATE_AUTH', authStore)
        resolve()
      })
    },
    messageHandlerSignIn (username, password) {
      var isIosMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios/)
      var isAndroidMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-android/)
      let data = {username: username, password: password}
      if (isAndroidMobileApp) {
        window.WebAppInterface.signInUserPass(JSON.stringify(data))
      } else if (isIosMobileApp) {
        window.webkit.messageHandlers.signInUserPass.postMessage(data)
      } else {
        localStorage.setItem('signIn', true)
        this.dispLoading()
        Auth.signIn(
          username,
          password, {ownerId: this.credentials.ownerId, ipAddress: this.IpAddress}
        )
          .then((user) => {
            this.removeLoading()
            if (user.challengeName === 'SMS_MFA') {
            // 二段階認証がONの場合
              this.cognitoUser = user
              this.loginProcess = 3
              this.error = ''
              this.mfaCode = ''
            } else {
              // 二段階認証がOFFの場合
              router.go('/dashboard')
            }
          })
          .catch((error) => {
            if (error.message.indexOf('PreAuthentication failed with error') !== -1) {
              this.error = 'ご使用の環境からはご利用出来ません'
            } else {
              if (this.isNTT) {
                this.error = '会員IDもしくはパスワードが間違っています。'
              } else {
                this.error = 'ユーザーIDもしくはパスワードが間違っています。'
              }
            }
            $('div#loading').remove()
          })
      }
    },
    messageHandlerProvider (provider) {
      var isIosMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios/)
      var isAndroidMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-android/)
      let data = {provider: provider}
      if (isAndroidMobileApp) {
        window.WebAppInterface.signInWithIdentityProvider(JSON.stringify(data))
      } else if (isIosMobileApp) {
        window.webkit.messageHandlers.signInWithIdentityProvider.postMessage(data)
      } else {
        this.setStartLogin()
          .then(() => Auth.federatedSignIn({provider: provider}))
      }
    },
    useGuest () {
      var isIosMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-ios/)
      var isAndroidMobileApp = navigator.userAgent.match(/alligate-mobile-userAgent-android/)
      if (isAndroidMobileApp) {
        window.WebAppInterface.loginGuest()
      } else if (isIosMobileApp) {
        console.log('postMessage : OK')
        window.webkit.messageHandlers.loginGuest.postMessage({})
      }
    },
    getIPAddress () {
      return fetch('https://api.ipify.org?format=json')
        .then((x) => x.json())
        .then(({ ip }) => {
          this.IpAddress = ip
        })
        .catch((err) => console.log(`Fetch problem 1: ${err}`))
    }
  }
}
</script>

<style>
/* Login web */
.login-button button {
    outline: inherit;
}
body{
  background: #394557
}
#loading {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999
}
#loading .loadingMsg {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 45px;
  height: 45px;
  background: url('../../../static/img/loading.gif') center center no-repeat;
  background-size: 100px 100px;
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
.gg-button button {
    background: #0022f5;
    color: #fff;
    padding: 9px 0px;
    border: none;
    margin-bottom: 11px;
}
.onelg-button button {
    background: #5d49f2;
    color: #fff;
    padding: 9px 0px;
    border: none;
    margin-bottom: 11px;

}
.appleid-button button {
    background: #ffab40;
    color: #fff;
    padding: 9px 0px;
    border: none;
}
.login-box-advanced .federated-login-button {
    height: 3rem;
}

.login-box-advanced .login-box-advanced-content .success-button .btn-success{
  height: 3rem;
}
.login-box-advanced .login-box-advanced-contents .login-input-error {
  float: right;
}
.login-layout .widget-box.visible {
  margin-top: 0%;
}
.login-layout {
    min-height: 100vh;
    display: grid;
    align-content: center;
}
#mainContainer {
  padding-top: 0px !important
}
.btn-back {
  position: absolute;
  left: 10px;
  top: 10px;
  color:#007F41
}
.btn-back:hover{
  cursor: pointer
}

.login-box-advanced .login-box-advanced-contents .alert {
  margin-bottom: 5px;
}
.login-box-advanced .federated-login-button {
  height: 3rem;
}
.federated-login-button {
    height: 40px;
    width: 100%;
    min-width: 200px;
    border: 1px solid transparent !important;
    border-radius: 7px;
    padding: 0px;
    /* text-align: left; */
    /* display: -webkit-box; */
    display: -ms-flexbox;
    /* display: flex; */
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
}
.federated-login-button img{
  width: 30px;
  height: 30px;
}
.federated-login-button .logo {
  height: 100%;
  width: 40px;
  margin-right: 12px;
}
.login-box-advanced-content {
    padding-top: 5px;
    padding-bottom: 5px;
}
.apple-logo {
    height: 100%;
    width: 100%;
}
.onelogin-logo {
    height: 100%;
    width: 100%;
}
.federated-login-button .logo img {
  widows: 46px;
  height: 46px;
}
.federated-login-button:focus-visible{
  border: 1px solid #fff !important;
}
.federated-login-button:active,
.federated-login-button:focus {
  -moz-outline-style: none !important;
  outline:none !important;
  outline:0 !important;
  -webkit-box-shadow: 0px 0px 3px #757575 !important;
  box-shadow: 0px 0px 3px #757575 !important;
}
.clear-margin {
    margin-top: 16px;
    margin-bottom: 16px;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.register-new-account-link {
    text-align: center;
    color: #007F41;
    padding: 0;
    display: block;
}
.register-new-account-link:hover {
    color: #007F41 !important;
}
@media only screen and (max-width: 500px) {
  #round-password{
    width: 85% !important;
  }
}
.btn-support-index{
  position: absolute;
  right: 100px;
  top:50px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}
.btn-support-index:hover,.btn-support-index:active{
  color: #fff;
}
.btn-support-index i {
  margin-right: 5px;
  margin-top: -1px;
  font-size: 30px;
  color: #fff;
}
.bg_black {
  background: #000000 !important
}
/* Login app */
.login-with-app .login-container{
  width: 100%;
  font-size: 18px;
  max-width: 800px !important;
  margin-bottom: 20px;
}
.login-with-app .login-button button {
    outline: inherit;
}
.login-with-app .login-layout .login-button button {
  background: #fff !important;
  color: #1B7E47 !important;
  border: none !important;
  font-weight: 700;
  position: relative;
  height: 45px;
  width: 350px;
  font-size: 16px !important;
}
.login-with-app .login-layout .login-button button .btn-icon {
  position: absolute;
  left: 20px;
  top: 13px;
  height: 20px;
}
.login-with-app .login-layout .login-button.btn-guest {
  margin-top: 10px;
}
.login-with-app .login-layout .login-button.btn-guest .btn-icon {
  top: 11px;
}
.login-with-app .login-layout .login-button.btn-guest button {
  background: none !important;
  color: #fff !important;
  border: solid 2px #fff !important;
}
.login-with-app .login-layout {
    min-height: 100vh;
    display: grid;
    align-content: center;
    background-repeat: no-repeat;
      background-size: cover;
    background-position: center;
}
.login-with-app #mainContainer {
  padding-top: 0px !important;
}
.login-with-app .btn-back {
  position: absolute;
  left: 10px;
  top: 50px;
  color:#fff
}
.login-with-app .form-item{
  position: relative;
  margin-bottom: 15px;
  width: 100%;
  padding-top: 5px ;
  margin: 10px auto 60px auto !important;
  height: 45px !important;
}
.login-with-app .form-item input{
  display: block;
  width: 100%;
  height: 36px;
  background: transparent;
  border: none;
  border-bottom: solid 1px #fff !important;
  transition: all 3s ease;
  font-size: 18px;
  color: #fff !important;
  position: absolute;
  z-index: 3;
}
.login-with-app .form-item input:focus{
  background: none !important;;
}
.login-with-app .form-item label{
  position: absolute;
  cursor: text;
  z-index: 2;
  top: 10px;
  left: 0px;
  background: none !important;
  color: #fff;
  transition: all .3s ease;
  font-size: 18px;
}
.login-with-app .form-item input:focus + label,
.login-with-app .form-item input:valid + label{
  font-size: 18px;
  top: -20px
}
.login-with-app .form-item input:focus + label{
  color: #fff
}
.login-with-app .form-item span.error{
  position: absolute;
  top: 100%;
  line-height: 16px;
}
.login-with-app  .icon-eye{
  position: absolute;
  right: 0px;
  top: 5px;
  z-index: 5;
}
.login-with-app  .icon-eye  img{
  width: 30px;
}
.login-with-app  .btn-icon-link {
  width: 15px;
}
.login-with-app  .forgot-password-text{
  color: #fff;
  font-size: 18px;
  margin-top: 10px;
  text-align: center;
}
.login-with-app  .forgot-password-text a{
  color: #fff;
}
.login-with-app  .i-logo{
  margin-bottom: 30px;
}
.login-with-app  .form-control{
  padding: 6px 12px !important;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to, .slide-leave {
  max-height: 500px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
@media only screen and (max-width: 500px) {
  .login-with-app .login-layout .login-button button {
    width: 90% !important;
  }
  .logo-login-default{
    margin-top: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/Index.vue